import React from 'react';
import { Button, IconSites, Modal } from 'gatorcomponents';
import * as Styles from './ModalRegisterDomain.styles';
import useLocale from '@/hooks/useLocale';
import { homeAnalytics } from '@/analytics/home';

const ModalRegisterDomain = ({
  setShowModalRegisterDomain,
  goToBuyDomain,
}) => {
  const { home: homeLocale } = useLocale();
  const modalLocale = homeLocale.v2.modalRegisterDomain;

  const handleCancel = () => {
    homeAnalytics.domainRegistrationCancel();
    setShowModalRegisterDomain(false);
  };

  const handleRegister = () => {
    homeAnalytics.domainRegistrationRegister();
    goToBuyDomain();
  };

  return (
    <Modal
      maxWidth={800}
      maxHeight={600}
      noHeader
      onClose={() => {
        setShowModalRegisterDomain(false);
      }}
    >
      <Styles.ModalContent>
        <Styles.ModalHeader>
          <IconSites size="md" />
          <Styles.Title>{modalLocale.title}</Styles.Title>
        </Styles.ModalHeader>

        <Styles.Description>{modalLocale.description}</Styles.Description>

        <Styles.WrapperButton>
          <Button
            label={modalLocale.buttonCancel}
            onClick={handleCancel}
            size="large"
            variant="tertiary"
            version="v2"
          />

          <Button
            label={modalLocale.buttonRegister}
            onClick={handleRegister}
            size="large"
            version="v2"
          />
        </Styles.WrapperButton>
      </Styles.ModalContent>
    </Modal>
  );
};

export default ModalRegisterDomain;
